import { useEffect } from 'react';

import { echo } from 'services/echo';

export interface NotificationPayload {
    [key: string]: unknown;
    rfq_id?: number;
    rfx_invite_id?: number;
    type: string;
}

// C15/D-028: the broadcast payload carries references only (no title/body/
// context — the allowlist has no display-text keys). Callers must treat
// `onNotification`/`onReconnect` as a PING and refetch display text from the
// 112 notification-centre API; never render fields off this payload.
const useUserNotifications = (
    userId: number | undefined,
    onNotification: (payload: NotificationPayload) => void,
    onReconnect?: () => void
): void => {
    useEffect(() => {
        if (!userId || !echo) {
            return;
        }

        const channelName = `App.Models.Auth.User.${userId}`;
        const channel = echo.private(channelName);

        channel.notification((payload: NotificationPayload) => {
            onNotification(payload);
        });

        const pusherConnection = echo.connector.pusher.connection;
        if (onReconnect) {
            pusherConnection.bind('connected', onReconnect);
        }

        return () => {
            if (onReconnect) {
                pusherConnection.unbind('connected', onReconnect);
            }
            echo?.leave(channelName);
        };
    }, [userId, onNotification, onReconnect]);
};

export { useUserNotifications };
